import { Injectable } from "@angular/core";

import { RaritySearchCriteria } from "@models/RaritySearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class RaritySearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<RaritySearchCriteria> {
    const criteria = await this.ps.getRaritySearchCriteria();
    return criteria;
  }
}
